import { render } from "./Oxygene.vue?vue&type=template&id=a889104c&scoped=true"
import script from "./Oxygene.vue?vue&type=script&lang=js"
export * from "./Oxygene.vue?vue&type=script&lang=js"

import "./Oxygene.vue?vue&type=style&index=0&id=a889104c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\giragwe\\Documents\\Github\\2022-PO-JER-GoogleMars\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a889104c"]])

export default __exports__